import { render, staticRenderFns } from "./spaceRequestsRSP.vue?vue&type=template&id=6c3c5f03&scoped=true&"
import script from "./spaceRequestsRSP.vue?vue&type=script&lang=js&"
export * from "./spaceRequestsRSP.vue?vue&type=script&lang=js&"
import style0 from "./spaceRequestsRSP.vue?vue&type=style&index=0&id=6c3c5f03&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3c5f03",
  null
  
)

export default component.exports